"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _spacing = _interopRequireDefault(require("../../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont: inherit;\n\tpadding: ", " ", ";\n\tline-height: 1.45;\n\tborder-bottom: 1px solid #eaeaea;\n\tcursor: pointer;\n\ttext-align: left;\n\t&:hover {\n\t\tbackground: #eaeaea;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var DropdownItem = _styledComponents.default.div(_templateObject(), _spacing.default.s1, _spacing.default.s2);

DropdownItem.displayName = 'DropdownItem';
/* @component */

var _default = DropdownItem;
exports.default = _default;